import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api';
// Async action for signup
export const studentProfileForm = createAsyncThunk('studnet/create', async (userData, { rejectWithValue }) => {
    try { 
   
      const response = await apiClient.post('/student/create', userData);
      return response.data; // Assuming backend returns the new user data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  });
  export const getStudentProfileForm = createAsyncThunk('studnet/getStudents', async (params, { rejectWithValue }) => {
    try { 
      const response = await apiClient.get('/student/all',{params: 
        {page:params?.page}, 
      });   
      return response.data; // Assuming backend returns the new user data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  });
  export const updateStudentProfileForm = createAsyncThunk('student/updateStudents', async (data, { rejectWithValue }) => {
    try { 
      const { formData, id }=data
      
      const response = await apiClient.put(`/student/update/${id}`,formData);
      return response.data; // Assuming backend returns the updated student data
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Return specific error from the server
      }
      return rejectWithValue({ message: 'An unknown error occurred' }); // Fallback for unknown errors
    }
  });
  export const deleteProfileForm = createAsyncThunk('student/deleteStudents', async (id, { rejectWithValue }) => {
    try { 
      const response = await apiClient.delete(`/student/delete/${id}`);
      
      return response.data; // Assuming backend returns the updated student data
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Return specific error from the server
      }
      return rejectWithValue({ message: 'An unknown error occurred' }); // Fallback for unknown errors
    }
  });
  export const studentApplication = createAsyncThunk(
    'student/studentApplication',
    async ({ params }, { rejectWithValue }) => {
      try {
        console.log(params,"paerams");
        
        const {university_id, page, search } = params;  
        // Ensure that the params object (including page) is passed correctly
        const response = await apiClient.get(`/application/university/${university_id}`, {
          params: {
            page,
            search // Include search in the request to the backend
          }
        });
  
        return response.data; // Return the response data from the API
      } catch (error) {
        if (error.response && error.response.data) {
          return rejectWithValue(error.response.data); // Return specific error message from the server
        }
        return rejectWithValue({ message: 'An unknown error occurred' }); // Fallback error
      }
    }
  );
  
  // Initial state
const initialState = {
    status: 'idle',
    students: [], // Initialize as an empty array
    totalCount:null,
    studentApplications:[],
    studentApplicationsTotalCount:null,
    error: null,
    isLoading: false,
    message: null,
  };
  // Slice
const studentSlice = createSlice({
    name: 'student',
    initialState,
    extraReducers: (builder) => {
      // Handle Get all University actions
      builder
      .addCase(studentProfileForm.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(studentProfileForm.fulfilled, (state, action) => {     
        state.status = 'succeeded';
        state.students = action.payload.data; // Store the array of universities from the payload
      
      })
      .addCase(studentProfileForm.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; // Capture the error from backend
      });
      builder
      .addCase(getStudentProfileForm.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getStudentProfileForm.fulfilled, (state, action) => {         
        state.status = 'succeeded';
        state.students = action.payload.data; // Store the array of universities from the payload
        state.totalCount = action.payload.totalCount;
  
      })
      .addCase(getStudentProfileForm.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; // Capture the error from backend
      });
      builder
      .addCase(updateStudentProfileForm.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateStudentProfileForm.fulfilled, (state, action) => {     
        state.status = 'succeeded';
      })
      .addCase(updateStudentProfileForm.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; // Capture the error from backend
      });
      builder
      .addCase(deleteProfileForm.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteProfileForm.fulfilled, (state, action) => {     
        state.status = 'succeeded';
      })
      .addCase(deleteProfileForm.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; // Capture the error from backend
      });
      builder
      .addCase(studentApplication.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(studentApplication.fulfilled, (state, action) => {         
        state.status = 'succeeded';
        state.studentApplications = action.payload.data; // Store the array of universities from the payload
        state.studentApplicationsTotalCount = action.payload.totalCount;
  
      })
      .addCase(studentApplication.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; // Capture the error from backend
      });
    },
  });
  
  export default studentSlice.reducer;